import config from 'app/config/config'
import { client } from 'app/shared/api/client'
import { AxiosResponse } from 'axios'

const parseErrorPayload = async (e: any): Promise<string | undefined> => {
  const status = e?.response?.status
  if (status === 403) {
    return 'User doesn\'t have permission to export trades.'
  }
  const data = e?.response?.data
  if (data instanceof Blob) {
    try {
      const text = await data.text()
      const parsed = JSON.parse(text)
      return parsed.error || parsed.message
    } catch {
      return undefined
    }
  }
  return data?.error
}

export const generateMasterTradeReport = async (
  tradeIds: string[],
  filters?: Record<string, string>,
  executedTimestamp?: string,
  timezone?: string,
) => {
  try {
    const response = await client.post<unknown, AxiosResponse<Blob>>(
      `${config.backendUrl}/api/trade-reports/master`,
      { tradeIds, filters, executedTimestamp, timezone },
      { responseType: 'blob' },
    )

    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = 'Master Trades Report.csv'
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)

    return { success: true }
  } catch (e: any) {
    console.error('Trade report generation failed:', e)
    return { success: false, payload: await parseErrorPayload(e) }
  }
}

export const generateSubTradeReport = async (
  tradeIds: string[],
  filters?: Record<string, string>,
  executedTimestamp?: string,
  timezone?: string,
) => {
  try {
    const response = await client.post<unknown, AxiosResponse<Blob>>(
      `${config.backendUrl}/api/trade-reports/subtrade`,
      { tradeIds, filters, executedTimestamp, timezone },
      { responseType: 'blob' },
    )

    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = 'SubTrades Report.csv'
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)

    return { success: true }
  } catch (e: any) {
    console.error('SubTrade report generation failed:', e)
    return { success: false, payload: await parseErrorPayload(e) }
  }
}
